import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import ClassNames from "classnames";
import RenderHtml from "../utils/render-html";

class FAQs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      n: 0
    };
  }

  renderContent(content) {
    return {
      __html: content
    };
  }

  render() {
    let data = this.props.data.allDatoCmsFaq;
    return (
      <div className="FAQs">
        <div className="bg" />
        <div className="internal">
          <h4>Frequently Asked Questions</h4>
          <div className="items">
            {data.edges.map((item, i) => {
              return (
                <div
                  className={ClassNames({
                    item: true,
                    ["is-active"]: i === this.state.n
                  })}
                  key={i}
                  onClick={() => {
                    if (this.state.n !== i) {
                      this.setState({ n: i });
                    }
                  }}
                >
                  <h5 className="question">{item.node.question}</h5>
                  {this.state.n === i && (
                    <div
                      className="answer"
                      dangerouslySetInnerHTML={RenderHtml.go(item.node.answer)}
                    />
                  )}
                  <div className="action">
                    {this.state.n === i && (
                      <span
                        className="action"
                        onClick={e => {
                          this.setState({
                            n: null
                          });
                        }}
                      >
                        -
                      </span>
                    )}
                    {this.state.n !== i && <span className="action">+</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default FAQs;

FAQs.propTypes = {
  data: PropTypes.shape({
    allDatoCmsFaq: PropTypes.object.isRequired
  }).isRequired
};

/* eslint no-undef: "off" */
export const query = graphql`
  query FaqQuery {
    allDatoCmsFaq {
      edges {
        node {
          id
          answer
          question
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/faqs.js